import { FC, useState, useEffect } from 'react'
import './CookieConsent.css'
import {useTranslation} from "../../providers/LocalizationProvider";

const CookieConsent: FC = () => {
	const [isVisible, setIsVisible] = useState(false)
	const { t } = useTranslation()

	useEffect(() => {
		const cookieConsent = localStorage.getItem('cookie-consent')
		if (!cookieConsent) {
			setIsVisible(true)
		}
	}, [])

	const handleAccept = () => {
		localStorage.setItem('cookie-consent', 'accepted')
		setIsVisible(false)
	}

	if (!isVisible) return null

	return (
		<div className='cookie-consent'>
			<div className='cookie-consent-content'>
				<p className='cookie-consent-text'>
					{t("cookie.text")}{' '}
					<a href='https://greencityre.com/privacy-policy' target="_blank" rel="noreferrer"  className='cookie-consent-link'>
						{t("cookie.more")}
					</a>
				</p>
				<button onClick={handleAccept} className='cookie-consent-btn'>
					{t("cookie.accept")}
				</button>
			</div>
		</div>
	)
}

export default CookieConsent
